<template>
  <div
    class="thank-you-wrapper row"
    :style="{
      '--borderColor': borderColor,
      '--textColor': textColor,
      '--textBeforeReferenceColor': textBeforeReferenceColor,
      '--referenceColor': referenceColor,
      '--mobileVisualBottomOffset': haveActivator ? '30%' : '20%'
    }"
  >
  <div class="col-sm-12 col-md-12 col-lg-12 main-header">
    <h1>Iti multumim pentru participarea la Campania </h1>
    <h4>„{{ campaignName }}”</h4>
  </div>
    <div class="content col-md-7 col-12">
      <div class="header">
        <p>Bonul fiscal/factura si datele tale ne-au fost trimise si sunt verificate momentan.</p>
      </div>
      <div class="reference-wrapper">
        <span v-if="textBeforeReferenceColor != '' ">
          <strong>
            <span class="text-before-ref">Numarul tau de referinta este:</span>
            <input class="reference-input" disabled="true" type="text" :value="referenceNumber" id="referenceNumber">
            <img v-if="copyImageSrc !=''" class="copy-icon" :src="copyImageSrc" alt="copy" @click="copy"/>
          </strong>
        </span>
        <span v-else>
          <strong>
            <span>Numarul tau de referinta este:</span>
            <input class="reference-input" disabled="true" type="text" :value="referenceNumber" id="referenceNumber">
            <img v-if="copyImageSrc !=''" class="copy-icon" :src="copyImageSrc" alt="copy" @click="copy"/>
            </strong>
        </span>
        <b-tooltip
          ref="tooltip"
          target="referenceNumber"
          noninteractive
        >
          Copiat în clipboard
        </b-tooltip>
      </div>
      <div class="info-section mb-5">
        <span
          >Dupa ce datele vor fi procesate. vei primi un e-mail de confirmare
          sau, daca datele sunt incomplete, vei primi un e-mail cu pasii
          necesari pentru aprobarea participarii tale. Verificarea poate dura 24
          de ore. Iti multumim pentru rabdare.</span
        >
      </div>
      <div class="home-button d-none d-sm-none d-md-block d-lg-block d-xl-block mt-5">
        <buttonComponent
          name="home"
          class="btn-link"
          @click.native="goToPage"
          text="Catre prima pagina"
        />
    </div>
    </div>
    <div class="visual col-md-5 col-12">
      <div class="activator">
        <img
          v-if="haveActivator"
          src="/assets/campaigns/ProtexCarrefour/activator.png"
        />
      </div>
      <div class="protex">
        <img
        :style="imageStyles"
        :class="classNames"
        :src="`/assets/campaigns/${campaign}/visual.png` || `/assets/campaigns/${campaign}/visual.jpg`" />
      </div>
    </div>
    <div class="home-button d-block d-sm-block d-md-none d-lg-none d-xl-none mb-5">
      <buttonComponent
        name="home"
        class="btn-link"
        @click.native="goToPage"
        text="Catre prima pagina"
       />
    </div>
  </div>
</template>

<script>
import buttonComponent from "@/components/renderers/button-component.vue";

export default {
  name: "thank-you",
  components: { buttonComponent },
  props: {
    imageSource: {
      required: false,
      type: String
    },
    classNames:{
      required: false,
      type: String
    },
    imageStyles: {
      type: Object,
      default: ()=>{}
    },
    campaign: {
      required: false,
      type: String,
      default: ""
    },
    campaignName: {
      required: false,
      type: String,
      default: ""
    },
    haveActivator: {
      required: false,
      type: Boolean,
      default: () => true
    },
    textColor: {
      required: false,
      type: String,
      default: "#0f2967"
    },
    referenceColor: {
      required: false,
      type: String,
      default: "#057dc3"
    },
    copyImageSrc: {
      required: false,
      type: String,
      default: ""
    },
    borderColor: {
      required: false,
      type: String,
      default: "#7997e1"
    },
    textBeforeReferenceColor: {
      required: false,
      type: String,
      default: ""
    }
  },
  methods: {
    goToPage() {
      window.location.href = "/";
    },
    copy() {
      var copyText = document.getElementById("referenceNumber");
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */
      navigator.clipboard.writeText(copyText.value);
      this.$refs.tooltip.$emit('open')
      setTimeout(() => {
        this.$refs.tooltip.$emit('close')
      }, 2000)
    }
  },
  computed: {
    referenceNumber() {
      return this.$store.state.formData["referenceNumber"];
    }
  }
};
</script>

<style scoped lang="scss">
.thank-you-wrapper {
  // position: relative;
  // padding-top: 70px;

  .content {
    position: relative;
    padding-top: 40px;
    @media (max-width: 767px) {
      padding: 30px 25px 0px;
    }

    .header {
      padding-bottom: 100px;
      h4 {
        color: var(--textColor);
        font-weight: 500;
        padding: 10px 0 50px;
        padding-bottom: 100px;
        @media (max-width: 767px) {
          padding: 10px 0 30px;
          p{
            padding-bottom: 50px;
          }
       }
      }
      @media (max-width: 767px) {
          padding: 10px 0 30px;
          padding-bottom: 50px;
       }
      // div {
      //   padding: 10px 0 50px;
      //   span {
      //     color: #12327d;
      //     font-size: 20px;
      //   }

      //   @media (max-width: 767px) {
      //     padding: 10px 0 30px;

      //     span {
      //       font-size: 14px;
      //     }
      //   }
      // }
    }

    .reference-wrapper {
      background: #ffffff;
      border: 1px solid var(--borderColor);
      box-sizing: border-box;
      border-radius: 16px;
      padding: 25px 30px;
      max-width: 500px;

      @media (max-width: 767px) {
        max-width: 442px;
        padding: 20px;
        span {
          font-size: 14px !important;
        }
      }

      span {
        color: var(--textColor);
        font-size: 16px;
        font-weight: normal;
        line-height: 26px;

        strong {
          color: var(--referenceColor);
        }
      }
    }

    .info-section {
      padding: 90px 0 60px;
      span {
        font-size: 12px;
        color: var(--textColor);
        line-height: 19px;
      }
      @media (max-width: 768px) {
        padding: 45px 0px 10px;
      }
    }

    .home-button {
      position: absolute;
      bottom: 10%;

      button {
        padding: 0;
      }

      @media (max-width: 767px) {
        bottom: 0;
      }
    }
  }

  .visual {
    @media (max-width: 767px) {
      padding-left: 0;
      padding-right: 0;
    }   
    .activator {
      min-height: 600px;
      @media (max-width: 767px) {
        min-height: 400px;
        img {
          width: 100%;
        }
      }
    }

    .protex {
      position: absolute;
      top: 0;
      @media (max-width: 992px)
      {
        top:40% !important;
      }
      img {
        width: 100%;
      }
      @media (max-width: 767px) {
        top: 5% !important;
        left: 7%;
        right: 7%;
        bottom: var(--mobileVisualBottomOffset);
      }
    }
  }
  .smoothies-helper {
    margin-left: 50%;    
    @media (max-width: 767px) {
      width: 250px !important;
      margin-left: 19% !important;
    }
    @media (max-width: 1000px) {
      margin-left: 20%;
    }
  } 
}
.main-header {
  color: var(--textColor);
  font-weight: 500;
  margin-top: 70px;
}
.text-before-ref{
  color: var(--textBeforeReferenceColor) !important;
}
.reference-input {
  width:100%;
  max-width:30%;
  margin-left: 10px;
  border:none;
  color: var(--referenceColor);
  font-family: inherit;
  background: transparent;
  font-weight: 700;
  @media (max-width:415px) {
    max-width: 50%;
  }
}
.copy-icon {
  cursor: pointer;
}
</style>
